import LogService from '../services/log.service';

export default {
  namespaced: true,
  state: {
    entries: [],
    totalLogs: null,
    query: {
      filters: {},
      sort: [],
      page: 1,
      limit: 30,
    },
  },
  mutations: {
    entries(state, entries) {
      state.entries = entries;
    },
    totalLogs(state, totalLogs) {
      state.totalLogs = totalLogs;
    },
    queryProps(state, props) {
      state.query = Object.assign({}, state.query, props);
    },
  },
  actions: {
    init({ dispatch }) {
      dispatch('getLogs');
    },
    getLogs({ commit, state }) {
      return LogService.getLogs(state.query)
        .then((res) => {
          commit('totalLogs', res.total);
          commit('entries', res.data);
        });
    },
  },
  getters: {
    logs(state) {
      return state.entries;
    },
  },
};
